<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="info"
          icon="mdi-shopping"
          title="Pedidos"
          :value="numPedidosTotal[0]"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="success"
          icon="mdi-currency-eur"
          title="Cantidad"
          :value="numPedidosTotal[1]"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <base-material-stats-card
          color="primary"
          icon="mdi-poll"
          title="Negocios"
          :value="pedidos.length.toString()"
          sub-icon="mdi-home"
          sub-text="Negocios del partner"
        />
      </v-col>
    </v-row>
    <v-container id="pedidos" tag="section">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <v-data-table
            :headers="headers"
            :items="pedidosTabla"
            :loading="loading"
            :search="search"
            :must-sort="true"
            sort-by="fecha"
            :sort-desc="true"
          >
            <template v-slot:item="{ item }">
              <tr :class="item.eliminado ? 'red lighten-2' : ''">
                <td>{{ item.numPedidoRest }}</td>
                <td>{{ item.fecha }}</td>
                <td>{{ item.modo }}</td>
                <td>{{ item.forma_pago }}</td>
                <td>{{ item.cantidad }}</td>
                <td>{{ item.nombreRest }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";
import moment from "moment-timezone";

export default {
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        {
          sortable: false,
          text: "Pedido Restaurante",
          value: "numPedidoRest",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Forma de pago",
          value: "forma_pago",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "cantidad",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "nombreRest",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      pedidos: (state) => state.pedidos.pedidosArray,
    }),
    pedidosTabla() {
      let res = [];
      this.pedidos.map((n) => {
        return n.array.map((p) => {
          res.push({
            ...p,
            nombreRest: p.copyNegocio.nombre + " " + p.copyRest.nombre,
            cantidad: mostrarMoneda(p.precioTotal),
            fecha: moment(p.fechaServidor.toDate()).format("HH:mm"),
          });
        });
      });
      return res;
    },
    numPedidosTotal() {
      const suma = (a, b) => a + b;
      let total = this.pedidos

        .map((p) => {
          return p.array
            .filter((p) => !p.eliminado)
            .reduce((a, b) => a + b.precioTotal, 0);
        })
        .reduce(suma, 0);
      let numPedidos = this.pedidos
        .map((p) => {
          return p.array.filter((p) => !p.eliminado).reduce((a, b) => a + 1, 0);
        })
        .reduce(suma, 0);
      return [numPedidos.toString(), mostrarMoneda(total)];
    },
  },
  mounted() {},
};
</script>

<style>
</style>